import type {ColorTokenGroup} from './types';

export const additional = {
  blueGrey: <ColorTokenGroup>{
    5: '#f3f5f6',
    10: '#eaedef',
    20: '#d0d7dc',
    30: '#b3bec7',
    40: '#9aa9b5',
    50: '#7b8f9e',
    60: '#637889',
    70: '#506372',
    80: '#415361',
    90: '#334250',
    100: '#25303c',
  },

  brown: <ColorTokenGroup>{
    5: '#f5f5f4',
    10: '#edebe8',
    20: '#dcd4cb',
    30: '#bdb2a8',
    40: '#9e8f80',
    50: '#84725e',
    60: '#725e4a',
    70: '#66523e',
    80: '#564533',
    90: '#493a2a',
    100: '#3b2b1c',
  },

  pink: <ColorTokenGroup>{
    5: '#fff0f7',
    10: '#fee6f1',
    20: '#ffc7e1',
    30: '#f89bc7',
    40: '#eb70b0',
    50: '#e151a1',
    60: '#d22d94',
    70: '#c41289',
    80: '#b2067e',
    90: '#9d0273',
    100: '#7d0366',
  },

  purple: <ColorTokenGroup>{
    5: '#fdf1fe',
    10: '#fae3fd',
    20: '#eebff2',
    30: '#dd90e4',
    40: '#c763cf',
    50: '#b343bd',
    60: '#a432ae',
    70: '#9726a1',
    80: '#8c1698',
    90: '#7e0b88',
    100: '#670470',
  },

  violet: <ColorTokenGroup>{
    5: '#f8f4ff',
    10: '#efeafe',
    20: '#d8cafc',
    30: '#bba0f5',
    40: '#a179ec',
    50: '#8e5ce5',
    60: '#8247e1',
    70: '#7535d4',
    80: '#6c20cf',
    90: '#5e08ba',
    100: '#460891',
  },

  indigo: <ColorTokenGroup>{
    5: '#f4f4ff',
    10: '#ebebff',
    20: '#d2d2ff',
    30: '#b2b3fa',
    40: '#9193f5',
    50: '#7375f4',
    60: '#5c5ee9',
    70: '#4b4ddd',
    80: '#3e3cce',
    90: '#3734bf',
    100: '#2b29a2',
  },

  blue: <ColorTokenGroup>{
    5: '#f0f7fc',
    10: '#e3f2fd',
    20: '#c0e3ff',
    30: '#93cdfc',
    40: '#64b5f6',
    50: '#42a5f5',
    60: '#2094f3',
    70: '#1e88e5',
    80: '#1976d2',
    90: '#1565c0',
    100: '#0d47a1',
  },

  cyan: <ColorTokenGroup>{
    5: '#eafcfd',
    10: '#dbf8fa',
    20: '#b6e9ed',
    30: '#81d5db',
    40: '#51c2ca',
    50: '#30b2bc',
    60: '#03a2ab',
    70: '#00949e',
    80: '#00858f',
    90: '#01757e',
    100: '#045961',
  },

  green: <ColorTokenGroup>{
    5: '#f3fdf0',
    10: '#e7fbe0',
    20: '#ccedc1',
    30: '#a8db97',
    40: '#84cb6d',
    50: '#6ac04d',
    60: '#56b238',
    70: '#46a527',
    80: '#3b961d',
    90: '#2b800e',
    100: '#1a6800',
  },

  red: <ColorTokenGroup>{
    5: '#fff5f6',
    10: '#ffebed',
    20: '#ffd2d2',
    30: '#ffa59e',
    40: '#fb7b6f',
    50: '#f45948',
    60: '#ee412b',
    70: '#e6341c',
    80: '#d82a13',
    90: '#c8250f',
    100: '#b21b00',
  },

  orange: <ColorTokenGroup>{
    5: '#fff5eb',
    10: '#ffeddb',
    20: '#ffd9b2',
    30: '#febf81',
    40: '#fca751',
    50: '#fb962b',
    60: '#f9820b',
    70: '#f97501',
    80: '#f26202',
    90: '#e55806',
    100: '#d14600',
  },

  yellow: <ColorTokenGroup>{
    5: '#fffadb',
    10: '#fdf6c3',
    20: '#fdec96',
    30: '#f7de6e',
    40: '#f5d142',
    50: '#fac529',
    60: '#f8b612',
    70: '#f6a904',
    80: '#f59700',
    90: '#e58600',
    100: '#cf7400',
  },

  olive: <ColorTokenGroup>{
    5: '#fdffdc',
    10: '#f8fabd',
    20: '#ebee96',
    30: '#dce067',
    40: '#c8cd42',
    50: '#b9be2d',
    60: '#abb01c',
    70: '#9da20e',
    80: '#8f9401',
    90: '#7c8001',
    100: '#5e6100',
  },
} as const;
